import React from "react";
//import Img from "gatsby-image";
import { StaticImage } from "gatsby-plugin-image";

const PopUpImage = ({ className }) => (
  <StaticImage
    src="../images/popup.jpg"
    quality="60"
    alt="Contratista de Proyectop y clienta dándose la mano en una terraza acristalada con vistas urbanas, tras finalizar una instalación de cerramiento en Madrid"
    placeholder="BLURRED"
    width={"800"}
    height={"800"}
    className={className}
  />
);

export default PopUpImage;
